export const createBasicAuthToken = (
  username: string,
  password: string,
): string => {
  return 'Basic ' + window.btoa(username + ':' + password);
};
